(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
document.querySelectorAll('[data-announcement-rotate]').forEach(function(bar){
  var msgs = bar.querySelectorAll('.announcement-bar__message');
  if(msgs.length < 2) return;
  var i = 0;
  var interval = parseInt(bar.dataset.interval) || 4000;
  setInterval(function(){
    msgs[i].classList.remove('is-active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active');
  }, interval);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function(){
  var sortSelect = document.querySelector('[data-sort-select]');
  if(sortSelect){
    sortSelect.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  function initProductPage(){
    var root = document.querySelector('[data-product-gallery]');
    if(!root) return;
    var slides = root.querySelectorAll('.product-gallery__slide');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var index = 0;
    function show(i){
      slides.forEach(function(s,idx){ s.classList.toggle('is-active', idx===i); });
      thumbs.forEach(function(t,idx){ t.classList.toggle('is-active', idx===i); });
      index = i;
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(parseInt(t.dataset.index,10)); }); });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if(prev) prev.addEventListener('click', function(){ show((index - 1 + slides.length) % slides.length); });
    if(next) next.addEventListener('click', function(){ show((index + 1) % slides.length); });

    // Accordion
    document.querySelectorAll('.accordion__trigger').forEach(function(trigger){
      trigger.addEventListener('click', function(){
        trigger.closest('.accordion__item').classList.toggle('is-open');
      });
    });

    // Variant selection
    var productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    var selectedOptions = {};
    document.querySelectorAll('.product-option').forEach(function(optEl){
      var selected = optEl.querySelector('.is-selected');
      if(selected) selectedOptions[optEl.dataset.optionPosition] = selected.dataset.optionValue;
    });

    function findVariant(){
      return productData.variants.find(function(v){
        return Object.keys(selectedOptions).every(function(pos){
          return v['option' + pos] === selectedOptions[pos];
        });
      });
    }

    function updateUI(variant){
      if(!variant) return;
      var pricePending = Number(variant.price) <= 0;
      var pendingText = window.veloriaStrings && window.veloriaStrings.pricePending ? window.veloriaStrings.pricePending : 'السعر قريبًا';
      var unavailableText = window.veloriaStrings && window.veloriaStrings.unavailableUntilPriced ? window.veloriaStrings.unavailableUntilPriced : 'غير متاح للشراء حتى تحديد السعر';
      document.querySelectorAll('[data-variant-id-input]').forEach(function(i){ i.value = variant.id; });
      document.querySelectorAll('.product-page, [data-product-price], [data-add-to-cart-form], [data-sticky-atc]').forEach(function(el){
        el.setAttribute('data-price-pending', pricePending ? 'true' : 'false');
      });
      var priceEls = document.querySelectorAll('[data-product-price] [data-price], [data-sticky-atc] [data-price]');
      priceEls.forEach(function(el){
        el.textContent = pricePending ? pendingText : formatMoney(variant.price);
        el.classList.toggle('price--pending', pricePending);
      });
      var compareEls = document.querySelectorAll('[data-compare-price]');
      var hasCompare = !pricePending && variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEls.forEach(function(el){ el.style.display = hasCompare ? '' : 'none'; if(hasCompare) el.textContent = formatMoney(variant.compare_at_price); });
      var badge = document.querySelector('[data-discount-badge]');
      if(badge) badge.style.display = hasCompare ? '' : 'none';
      var addBtn = document.querySelector('[data-add-to-cart-btn]');
      var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
      [addBtn, stickyBtn].forEach(function(btn){
        if(!btn) return;
        btn.setAttribute('data-price-pending', pricePending ? 'true' : 'false');
        btn.disabled = pricePending || !variant.available;
        btn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
        var label = btn.querySelector('.btn-text') || btn;
        label.textContent = pricePending ? unavailableText : variant.available ? (window.veloriaStrings ? window.veloriaStrings.addToCart : 'Add to Cart') : (window.veloriaStrings ? window.veloriaStrings.soldOut : 'Sold Out');
      });
      var buyNow = document.querySelector('[data-buy-now]');
      if(buyNow){
        if(!buyNow.getAttribute('data-ready-label')) buyNow.setAttribute('data-ready-label', buyNow.textContent.trim());
        buyNow.setAttribute('data-price-pending', pricePending ? 'true' : 'false');
        buyNow.disabled = pricePending || !variant.available;
        buyNow.setAttribute('aria-disabled', buyNow.disabled ? 'true' : 'false');
        buyNow.textContent = pricePending ? unavailableText : buyNow.getAttribute('data-ready-label');
      }
      var stockEl = document.querySelector('[data-stock-status]');
      if(stockEl){
        stockEl.classList.toggle('is-in-stock', variant.available);
        stockEl.classList.toggle('is-out-stock', !variant.available);
      }
    }

    function formatMoney(cents){
      if(window.Veloria && typeof window.Veloria.formatMoney === 'function') return window.Veloria.formatMoney(cents);
      return String(Number(cents) / 100);
    }

    document.querySelectorAll('.swatch-option, .size-option').forEach(function(btn){
      btn.addEventListener('click', function(){
        var pos = btn.dataset.optionPosition;
        var group = btn.closest('.product-option');
        group.querySelectorAll('.swatch-option, .size-option').forEach(function(b){ b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        group.querySelector('[data-selected-option-value]').textContent = btn.dataset.optionValue;
        selectedOptions[pos] = btn.dataset.optionValue;
        updateUI(findVariant());
      });
    });

    // Sticky ATC visibility + sync click with main add to cart
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    var mainForm = document.getElementById('product-form');
    if(stickyAtc){
      window.addEventListener('scroll', function(){
        var formRect = mainForm.getBoundingClientRect();
        stickyAtc.classList.toggle('is-visible', formRect.bottom < 0);
      }, { passive: true });
      var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
      if(stickyBtn){
        stickyBtn.addEventListener('click', function(){
          mainForm.querySelector('[data-add-to-cart-btn]').click();
        });
      }
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initProductPage); } else { initProductPage(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
(function(){
  var STORAGE_KEY = 'veloria_recently_viewed';
  var MAX_ITEMS = 8;

  function formatMoney(cents){
    if(window.Veloria && typeof window.Veloria.formatMoney === 'function') return window.Veloria.formatMoney(cents);
    return String(Number(cents) / 100);
  }

  function track(handle){
    if(!handle) return;
    try{
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      list = list.filter(function(h){ return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    }catch(e){}
  }

  function render(){
    var section = document.querySelector('[data-recently-viewed]');
    if(!section) return;
    var productsToShow = parseInt(section.dataset.productsToShow, 10) || 4;
    var currentHandle = window.location.pathname.split('/').pop();
    if(document.body.classList.contains('template-product')) track(currentHandle);

    var list = [];
    try{ list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }catch(e){}
    list = list.filter(function(h){ return h !== currentHandle; }).slice(0, productsToShow);
    if(list.length === 0) return;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    var template = document.getElementById('recently-viewed-card-template');
    var loaded = 0;
    list.forEach(function(handle){
      fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if(!p) return;
        var node = template.content.cloneNode(true);
        var img = node.querySelector('img');
        img.src = p.featured_image;
        img.alt = p.title;
        node.querySelector('a.ratio').href = '/products/' + p.handle;
        var titleLink = node.querySelector('.product-card__title');
        titleLink.href = '/products/' + p.handle;
        titleLink.textContent = p.title;
        node.querySelector('.price').textContent = formatMoney(p.price);
        grid.appendChild(node);
        loaded++;
        section.style.display = '';
      });
    });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', render); } else { render(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function(){
  function initRelated(){
    var section = document.querySelector('[data-related-products]');
    if(!section) return;
    var grid = section.querySelector('#related-products-grid');
    if(grid.children.length > 0){ section.classList.add('has-results'); return; }
    fetch(section.dataset.url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newGrid = temp.querySelector('#related-products-grid');
        if(newGrid && newGrid.children.length > 0){
          grid.innerHTML = newGrid.innerHTML;
          section.classList.add('has-results');
        }
      })
      .catch(function(){});
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initRelated); } else { initRelated(); }
})();

  } catch(e) { console.error(e); }
})();
})();
